import script from "./member.vue?vue&type=script&lang=ts&setup=true"
export * from "./member.vue?vue&type=script&lang=ts&setup=true"

import "./member.vue?vue&type=style&index=0&id=5e9d19d9&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e9d19d9"]])

export default __exports__